import {Button, Divider, Spinner, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import {useEffect, useState } from "react";
import InputWithBarcode from "../InputWithBarcode";
import { getAxiosInstance } from "../../utils/axiosInstance";
import { toast } from "react-toastify";
import { BsFillBoxSeamFill } from "react-icons/bs";
import { NewProduct } from "../../pages/Inventory/components/Product";

interface SearchProductInInventoryInterface {
  addProduct: (data: NewProduct & { id: string, quantity: number}) => void;
  placeOfBusinessId?: string;
};

const SearchProductInInventory = (props: SearchProductInInventoryInterface) => {
  const { t } = useTranslation("translations");

  const [barcode, setBarcode] = useState<string>("");
  const [product, setProduct] = useState<any>([]);
  const [loadingProducts, setLoadingProducts] = useState<boolean>(false);

  const searchProduct = async (code: string) => {
    setLoadingProducts(true);
    try {
      const res = await getAxiosInstance().get(`/Inventory/PlaceOfBusiness/${props.placeOfBusinessId}/${code}`);
      setProduct(res.data);
    } catch (e) {
      toast.warn(t("CAN_T_FIND_PRODUCT_WITH_BARCODE") as string, { position: "bottom-right" });
    } finally {
      setLoadingProducts(false);
    }
  }

  const addExistingProduct = (index: number) => {
    props.addProduct(product[index]);
    setProduct([]);
    setBarcode("");
  }

  useEffect(() => {
    if(barcode.length > 3) {
      searchProduct(barcode);
    }
  }, [barcode, props.placeOfBusinessId]);
  
  return (
    <div className="mt-4">
      <Text className="mb-1" fontWeight="semibold">{t('ADD_PRODUCT')}</Text>
      <Divider className="mb-4 mt-2" />
      <InputWithBarcode
        value={barcode}
        setValue={(data: string) => setBarcode(data)}
        placeholder={t("SCAN PRODUCT")}
        isDisabled={!props.placeOfBusinessId}
      />
      <div className={`relative mt-2 ${loadingProducts ? "bg-red-200 opacity-40 pointer-events-none" : ""}`}>
        {
          loadingProducts &&
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
            <Spinner />
          </div>
        }

        {
          product.map((x: any, index: number) =>
              <Button
                key={`product-${index}`}
                variant="solid"
                colorScheme='teal'
                leftIcon={<BsFillBoxSeamFill />}
                width="100%"
                onClick={() => addExistingProduct(index)}
              >
                {x.productName}
              </Button>
          )
        }
      </div>
    </div>
  )
};

export default SearchProductInInventory;